__turbopack_context__.v({
  "closeButton": "ToastModal-module__2RBfoG__closeButton",
  "content": "ToastModal-module__2RBfoG__content",
  "fadeIn": "ToastModal-module__2RBfoG__fadeIn",
  "iconContainer": "ToastModal-module__2RBfoG__iconContainer",
  "message": "ToastModal-module__2RBfoG__message",
  "modal": "ToastModal-module__2RBfoG__modal",
  "modal--error": "ToastModal-module__2RBfoG__modal--error",
  "modal--info": "ToastModal-module__2RBfoG__modal--info",
  "modal--success": "ToastModal-module__2RBfoG__modal--success",
  "overlay": "ToastModal-module__2RBfoG__overlay",
  "slideIn": "ToastModal-module__2RBfoG__slideIn",
});
